import {
	type MessageInstanceClickedParams,
	useMessageInstanceEvent,
} from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { JiraMessagingResearchRecruitmentFlag } from './components/flag';
import { createRender } from './types';

export const render = createRender(() => {
	const { messageInstanceClicked } = useMessageInstanceEvent();
	const { messageClicked, messageDismissed } = useMessageEvent();

	/***************************** Analytic Event Handlers *****************************/

	// Handles the primary CTA click event (when use clicks on survey link)
	const handlePrimaryCTA = useCallback(async () => {
		const clickEvent: MessageInstanceClickedParams = {
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'surveyLink',
				clickedElement: 'link',
			},
			action: {
				actionType: 'open',
				destinationUrl: 'https://www.userinterviews.com/projects/-eEm9Lz9KQ/apply',
			},
			additionalMetadataFromFrontend: {},
		};
		void messageClicked();
		void messageInstanceClicked(clickEvent);

		void messageDismissed();
	}, [messageClicked, messageDismissed, messageInstanceClicked]);

	// Permanently dismisses the message (used for ad control when a user never wants to see the message again)
	const handleDismiss = useCallback(() => {
		void messageInstanceClicked({
			messageEventType: 'clicked',
			clickedElement: {
				clickIdentifier: 'dismiss',
				clickedElement: 'button',
				buttonType: 'primary',
			},
			action: {
				actionType: 'dismiss',
			},
			additionalMetadataFromFrontend: {},
		});

		void messageDismissed();
	}, [messageDismissed, messageInstanceClicked]);

	return (
		<JiraMessagingResearchRecruitmentFlag
			width={380}
			header={
				<FormattedMessage
					id="post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header"
					description="Header for Jira Messaging Research Recruitment message in Screen Space Flags"
					defaultMessage="Share your experience for $120 USD"
				/>
			}
			description={
				<FormattedMessage
					id="post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description"
					description="Description for Jira Messaging Research Recruitment message in Screen Space Flags"
					defaultMessage="Help us improve messaging for Atlassian Admins! Answer a few short questions, and our
					Research team will contact you for a 60-minute Zoom session if you qualify."
				/>
			}
			onPrimaryCTAClicked={handlePrimaryCTA}
			onDismissedPermanently={handleDismiss}
		/>
	);
});

export default render;
